import React from "react";
import { useAppState } from "../application/AppState";
import { Grid, FormControlLabel, List, ListItem, Box, Checkbox } from "@material-ui/core";
import { CloudDownload } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import useTranslation from "../application/translation";




const PresaleDocs = () => {
    const [{ customer, insurances }] = useAppState();
    const [showAlldocs, setShowAlldocs] = React.useState(false);
    const translation = useTranslation();

    const handleChange = (event) => {
        setShowAlldocs(event.target.checked);
    };

    const filterDocs = () => {
        var docList = [];

        if (showAlldocs === true) {
            return customer.preSaleDocs;
        }

        customer.preSaleDocs.forEach(function (doc) {
            if (insurances.find(x => x.productType == doc.type)) {
                docList.push(doc);
            }
        });       
        return docList;
    }

    return (
        <Box style={{ paddingTop: '15px' }} spacing={2}>
            <FormControlLabel
                control={
                    <Checkbox                       
                        defaultChecked={false}
                        onChange={handleChange}
                    />
                }
                label={translation.presaledoc_showAll}
            />
            <List dense>
                {filterDocs().map((x) => (
                    <>
                        <ListItem>
                            <Button variant="link" startIcon={<CloudDownload color="primary" />} target="_blank" href={process.env.PUBLIC_URL + "/Documents/PreSale/" + x.docName}>
                                {x.displayName}
                            </Button>
                        </ListItem>
                    </>
                ))}
            </List>
        </Box>
    );
}

export default PresaleDocs;